import React from "react";
import Marquee from "react-fast-marquee";

interface IClientContainerComponentProps { }

export const ClientContainerComponent: React.FC<
    IClientContainerComponentProps
> = (props: IClientContainerComponentProps) => {
    const clients = [
        "/assets/img/clients/client-tata.jpg",
        "/assets/img/clients/client-capgemini.svg",
        "/assets/img/clients/client-harman.jpg",
        "/assets/img/clients/client-nice.jpeg",
        "/assets/img/clients/client-eaton.jpg",
        "/assets/img/clients/client-asianpaints.jpg",
        "/assets/img/clients/client-ppgasian.jpg",
        "/assets/img/clients/client-aam.png",
        "/assets/img/clients/client-kdrive.jpg",
        "/assets/img/clients/client-bekaert.png",
        "/assets/img/clients/client-deserve.png",
        "/assets/img/clients/client-vuclip.png",
        "/assets/img/clients/client-racold.png",
        "/assets/img/clients/client-ariston.png",
        "/assets/img/clients/client-endurance.png",
        "/assets/img/clients/client-shriram.jpg",
        "/assets/img/clients/client-modern.webp",
        "/assets/img/clients/client-dastur.png",
        "/assets/img/clients/client-hendrickson.svg",
        "/assets/img/clients/client-hansaflex.jpg",
        "/assets/img/clients/client-diacto.jpg",
        "/assets/img/clients/client-ctcglobal.jpg",
        "/assets/img/clients/client-fern.png",
        "/assets/img/clients/client-kanaka.png",
        "/assets/img/clients/client-sarvatra.jpg",
        "/assets/img/clients/client-maher.png",
        "/assets/img/clients/client-aliengena.jpg",
        "/assets/img/clients/client-bhimashankar.jpg",
        "/assets/img/clients/client-sitabaitithecollege.webp",
        "/assets/img/clients/client-education.jpg",
        "/assets/img/clients/client-entralai.jpg",
        "/assets/img/clients/client-indusolutions.jpg",
        "/assets/img/clients/client-suyashgroup.jpg",
        "/assets/img/clients/client-kgnxprs.jpg",
        // "assets/img/clients/client-haimer.jpg",
        // "assets/img/clients/client-antolin.png",
    ];

    return (
        <section id="clients" className="clients section">
            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <h5>
                    Trusted by small, medium, and large enterprises Pan India.
                </h5>
                <br />
                <Marquee speed={30}>
                    <div className="p-4">
                        {clients?.map((client: string, index: number) => {
                            return (
                                <span key={index} className="p-4">
                                    <img loading="lazy"
                                        src={client}
                                        height={80}
                                        width={200}
                                        style={{ objectFit: "contain" }}
                                        alt="client-svg-icon"
                                    />
                                </span>
                            );
                        })}
                    </div>
                </Marquee>
            </div>
        </section>
    );
};
